<template>
    <tr class="filter-row">
        <slot></slot>
    </tr>
</template>

<script>
import { debounce } from '@/utils';

export default {
    props: ['filterData', 'changeHandler'],
    watch: {
        filterData: {
            deep: true,
            handler() {
                this.debounce();
            }
        }
    },
    created() {
        this.debounce = debounce(this.changeHandler, 750);
    }
};
</script>
<style>
#myApp .v-data-table .filter-row td:hover {
    border-color: #363e59;
}
</style>
